import ActionsList from 'core/actions/Actions.list';
import { actionCoreApi } from 'core/utils/api';
import { actionErrorNotifier } from 'core/utils/helpers';
import { ActionType } from 'core/utils/interfaces';
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper';
import { ISort, IFilters } from 'core/actions/Actions.interfaces';

export const fetchGroupList = (accountId: string, params: ISort, filters?: IFilters): ActionType =>
actionErrorNotifier(actionCoreApi(
  ActionsList.FetchFeatureFlag,
  HTTPUrlHelper.fetchGroupList(accountId, params, filters),
))

export const fetchGroupDetails = (groupId: string): ActionType =>
actionErrorNotifier(actionCoreApi(
  ActionsList.FetchFeatureFlag,
  HTTPUrlHelper.fetchGroupDetails(groupId),
))

export const fetchRolesByAccountId = (accountId: string): ActionType =>
actionErrorNotifier(actionCoreApi(
  ActionsList.FetchFeatureFlag,
  HTTPUrlHelper.getRolesByAccountId(accountId),
))

export const assignRolesToGroup = (groupId: string, payload: any): ActionType =>
actionErrorNotifier(actionCoreApi(
  ActionsList.FetchFeatureFlag,
  HTTPUrlHelper.assignRolesToGroup(groupId),
  'POST',
  payload,
))
